import { render, staticRenderFns } from "./AccountBankList.vue?vue&type=template&id=5885b045"
import script from "./AccountBankList.vue?vue&type=script&lang=js"
export * from "./AccountBankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports